import { ProspectResidenceLookupRequest } from './prospect-residence-lookup-request';

export class ProspectLivingAreaLookupRequest extends ProspectResidenceLookupRequest {
  unit?: string;
  numberFrom?: string;
}
